import { Component, ElementRef, Inject, OnInit } from '@angular/core';
import { InicioJardinComponent } from '../../inicio-jardin.component';

@Component({
  selector: 'app-preguntas-frecuentes',
  templateUrl: './preguntas-frecuentes.component.html',
  styleUrls: ['./preguntas-frecuentes.component.css']
})
export class PreguntasFrecuentesComponent implements OnInit {

  constructor(private el:ElementRef,@Inject(InicioJardinComponent) private parent: InicioJardinComponent,) { }

  ngOnInit(): void {
  }


  volver(){
    this.parent.ngOnInit();
  }

}
